<ng-container *ngIf="isWebSite; then landing; else cabinet"></ng-container>
<ng-template #landing>
  <div [ngClass]="{ mobile_active: active }" class="mobile">
    <div class="mobile-wrap">
      <div class="mobile-header">
        <div class="mobile-logo">
          <img [src]="env.LOGO_WHITE" alt="logo"/>
        </div>
        <div (click)="hamburgerEvent.emit()" class="mobile-hamburger">
          <span class="mobile-hamburger__line"></span>
        </div>
      </div>
      <app-header-buttons (onNavigateEvent)="itemClickEvent.emit()" class="w-100"></app-header-buttons>
      <div class="mobile-menu">
        <div *ngFor="let item of items" [routerLinkActiveOptions]="{ exact: true }" class="mobile-menu__item"
             routerLinkActive="active">
          <a (click)="itemClickEvent.emit()" [routerLink]="item.route" class="mobile-menu__link" matRipple>
            {{ item.label | translate }}
          </a>
        </div>
      </div>
      <div class="mobile-help">
        <div class="mobile-help__top">
          <h4>Потрібна допомога?</h4>
          <div *ngFor="let item of phones" class="mobile-help__top-phone">
            <img alt="icon" height="18" src="assets/images/icons/icon-phone-mal.png" width="11"/>
            <a [href]="item.contact">{{ item.label }}</a>
          </div>
        </div>
        <div class="mobile-help__bottom">
          <h5>Служба підтримки працює:</h5>
          <div class="mobile-help__bottom-down">
            <img alt="icon" height="20" src="assets/images/icons/Time.svg" width="20"/>
            <span>Пн-Нд: 9:00 - 21:00</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cabinet>
  <div [ngClass]="{ mobile_active: active }" class="mobile">
    <div class="mobile-wrap">
      <div class="mobile-header d-flex justify-content-between align-items-center">
        <div class="mobile-logo">
          <a [href]="env.WEBSITE_URL">
            <img [src]="env.LOGO_WHITE" alt="" class="header-logo-icon" height="100%" width="100%"/>
          </a>
        </div>
        <div (click)="hamburgerEvent.emit()" [ngClass]="{ hamburger_active: active }" class="hamburger">
          <span class="hamburger__line"></span>
        </div>
      </div>
      <menu *ngIf="isMenu" class="mobile-menu">
        <li *ngFor="let item of items" [routerLinkActiveOptions]="{ exact: true }" class="mobile-menu__item"
            routerLinkActive="active">
          <a (click)="itemClickEvent.emit()" [routerLink]="item.route"
             class="mobile-menu__link d-flex align-items-center">
              <span class="mobile-menu__icon mr-2">
                <img [src]="item.img.url" [style.height]="item.img.height || ''" [style.width]="item.img.width || ''"
                     alt="icon"/>
              </span>
            {{ item.label | translate }}
          </a>
        </li>
        <li (click)="logoutEvent.emit()" class="mobile-logout cursor-pointer">
          <img alt="logout" src="./assets/images/icons/logout.svg"/>
          <span class="mobile-logout-label">{{ 'BUTTON.LOGOUT' | translate }}</span>
        </li>
      </menu>
      @if (payment()?.visible) {
        <app-payment-button [payment]="payment()" class="mt-5"></app-payment-button>
      }
    </div>
  </div>
</ng-template>
